import React, { useState, useId } from 'react';
import { Info } from 'lucide-react';

export interface WhyWeAskProps {
  children: React.ReactNode;
}

/**
 * Collapsible "Why we ask" disclosure. Hidden by default; click to expand.
 * Brand voice: the explanation should be a short declarative sentence, no
 * marketing language, no exclamation points.
 */
export function WhyWeAsk({ children }: WhyWeAskProps) {
  const [open, setOpen] = useState(false);
  const contentId = useId();
  return (
    <div className="aa-why-we-ask">
      <button
        type="button"
        className="aa-why-toggle"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        aria-controls={contentId}
      >
        <Info size={12} strokeWidth={2} aria-hidden="true" />
        Why we ask
      </button>
      {open && (
        <div id={contentId} className="aa-why-content">
          {children}
        </div>
      )}
    </div>
  );
}

export default WhyWeAsk;
